import { LoadingIndicator } from '@festo-ui/react';
import LoginLink from './LoginLink';
import PricingComponent from './PricingComponent';
import { useAuth } from 'react-oidc-context';
import { PricingItemResponse } from '../../../../features/pricing/api';
import { useAppSelector } from '../../../../app/hooks';
import { isLoginRedirect } from '../../../../utils';

interface PriceCellProps {
  price: PricingItemResponse | null;
}

const Login = ({ price }: PriceCellProps) => {
  const auth = useAuth();
  const { isLoading } = useAppSelector((state) => state.pricing);
  const loggedIn = auth.isAuthenticated;

  if ((isLoading === 'idle' || isLoading === 'pending') && isLoginRedirect() && !loggedIn)
    return (
      <div className="ps-price-cell-loader">
        <LoadingIndicator size="small" />
      </div>
    );

  else if (!loggedIn) return <LoginLink />;

  return <PricingComponent price={price} />;
};

export default Login;
